export default {"src":"/_next/static/image/components/ui/Icon/icons/bookmark.e20146e135eabdbd11458eab72ed383a.svg","height":22,"width":17};